// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Shared chip Value field — Rule Config + Pipeline Rules (mat-form-field notched outline). */
.rule-value-inline-shell {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-sizing: border-box;
  min-height: 20px;
  height: auto;
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
  border-radius: 0;
}

/* Inside mat-form-field — clear floated label notch; chips must not touch top border */
.rule-value-inline-field .rule-value-inline-shell {
  padding: 8px 0 4px;
}

.rule-value-inline-chips {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
  max-width: 100%;
  max-height: 96px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  box-sizing: border-box;
  scrollbar-width: thin;
  scrollbar-color: #94a3b8 transparent;
}
.rule-value-inline-chips::-webkit-scrollbar {
  width: 6px;
}
.rule-value-inline-chips::-webkit-scrollbar-thumb {
  background: #94a3b8;
  border-radius: 3px;
}

.rule-value-inline-input {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 20px;
  flex: 0 0 auto;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  font-size: 12px;
  line-height: 20px;
  background: transparent;
  box-sizing: border-box;
}

.rule-value-inline-input::placeholder {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.42);
  opacity: 1;
}

.rule-value-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  padding: 3px 6px 3px 10px;
  background: #e8f4fd;
  border: 1px solid #7dd3fc;
  border-radius: 16px;
  box-sizing: border-box;
}

.rule-value-tag-text {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 200px;
  font-size: 11px;
  line-height: 1.35;
  color: #0c4a6e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rule-value-tag-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}
.rule-value-tag-remove mat-icon {
  width: 14px;
  height: 14px;
  font-size: 14px;
  line-height: 14px;
}
.rule-value-tag-remove:hover {
  background: #fee2e2;
  color: #dc2626;
}

:host ::ng-deep {
  /* Rule Name row — keep empty label centered; floated state sits on notch with gap */
}
:host ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled),
:host ::ng-deep .mdc-text-field--focused,
:host ::ng-deep .mdc-text-field--filled,
:host ::ng-deep .mat-mdc-form-field {
  background-color: #fff !important;
  --mdc-filled-text-field-focus-active-indicator-color: none !important;
}
:host ::ng-deep .mat-mdc-form-field-type-mat-input,
:host ::ng-deep .mat-mdc-form-field-type-mat-select {
  --mdc-filled-text-field-focus-label-text-color: black;
}
:host ::ng-deep .mat-mdc-form-field-type-mat-input .mat-mdc-form-field-subscript-wrapper,
:host ::ng-deep .mat-mdc-form-field-type-mat-select .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host ::ng-deep .mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-form-field-infix {
  min-height: 40px !important;
  padding-top: 14px !important;
  padding-bottom: 6px !important;
}
:host ::ng-deep .mat-mdc-raised-button.mat-basic {
  background-color: white;
  color: #17A2B8;
  border: 1px #17A2B8 solid;
}
:host ::ng-deep .mat-mdc-raised-button.mat-primary {
  background-color: #17A2B8;
  color: white;
}
:host ::ng-deep .mat-mdc-raised-button:disabled {
  color: grey;
}
:host ::ng-deep .cardContect {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
:host ::ng-deep .matoutlinestyles.mat-mdc-form-field .mdc-text-field--outlined {
  padding: 3px 8px 3px 8px !important;
}
:host ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {
  top: 22px;
}
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label,
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mdc-floating-label {
  top: -9px !important;
  transform: scale(0.75) !important;
  transform-origin: left top;
  background: #fff;
  padding: 0 4px;
}
:host ::ng-deep .rule-name.mat-mdc-form-field .mdc-floating-label:not(.mdc-floating-label--float-above) {
  top: 50% !important;
  transform: translateY(-50%) !important;
}
:host ::ng-deep .rule-name.mat-mdc-form-field .mdc-floating-label--float-above {
  top: -9px !important;
  transform: scale(0.75) !important;
  transform-origin: left top;
  background: #fff;
  padding: 0 4px;
}
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field {
  width: 100%;
  margin: 0 !important;
  align-self: flex-start;
  overflow: visible !important;
  --mat-form-field-container-height: auto !important;
  --mdc-outlined-text-field-container-height: auto !important;
  /* floatLabel="always" + chip content — keep Value label on the outline notch */
}
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field .mat-mdc-text-field-wrapper,
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field .mdc-text-field--outlined {
  min-height: 36px !important;
  max-height: 140px !important;
  height: auto !important;
  overflow: visible !important;
  background: #ffffff !important;
  border-radius: 4px;
}
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field .mat-mdc-form-field-flex {
  max-height: 140px !important;
  height: auto !important;
  overflow: visible !important;
  align-items: flex-start;
}
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field .mat-mdc-form-field-infix {
  max-height: 130px !important;
  height: auto !important;
  min-height: 28px !important;
  width: 100%;
  overflow: visible !important;
  padding-top: 4px !important;
  padding-bottom: 8px !important;
}
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field .mdc-notched-outline__leading,
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field .mdc-notched-outline__notch,
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field .mdc-notched-outline__trailing {
  border-color: #cfd8e3 !important;
}
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field .mat-mdc-floating-label,
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field .mdc-floating-label {
  top: -9px !important;
  transform: scale(0.75) !important;
  transform-origin: left top;
  background: #fff;
  padding: 0 4px;
  color: rgba(0, 0, 0, 0.6) !important;
  font-size: 12px !important;
  z-index: 1;
}
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field.mat-focused .mdc-notched-outline__leading, :host ::ng-deep .rule-value-inline-field.mat-mdc-form-field.mat-focused .mdc-notched-outline__notch, :host ::ng-deep .rule-value-inline-field.mat-mdc-form-field.mat-focused .mdc-notched-outline__trailing {
  border-color: #0f766e !important;
}
:host ::ng-deep .rule-value-inline-field.mat-mdc-form-field.mat-focused .mat-mdc-floating-label, :host ::ng-deep .rule-value-inline-field.mat-mdc-form-field.mat-focused .mdc-floating-label {
  color: #0f766e !important;
}

.rule-name-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  max-width: 100%;
}

.rule-in-expression-icon {
  color: #16a34a;
  font-size: 14px;
  flex-shrink: 0;
}

.rule-value-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  max-width: 100%;
}

.rule-value-primary {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.rule-value-extra-badge {
  flex-shrink: 0;
  color: #2563eb;
  font-size: 12px;
  font-weight: 600;
}

.edit-button {
  height: 100%;
  width: 100%;
  background-color: #F5F5F5;
  border-radius: 0px 10px 0px 0px;
  cursor: pointer;
}

.delete-button {
  height: 100%;
  width: 100%;
  background-color: #F5F5F5;
  border-radius: 0px 0px 10px 0px;
  cursor: pointer;
}

.create-rule-part-1 {
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 auto;
  align-items: flex-start;
  padding: 1% 2% 0.5% 2%;
}

.create-rule-part-2 {
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  padding: 0.5% 2% 1% 2%;
  margin-top: 8px;
}

.field {
  width: 46%;
  margin-right: 1%;
}

.select-operator {
  width: 14%;
  margin-left: 1%;
  margin-right: 1%;
}

.value {
  width: 36%;
  margin-left: 1%;
}

.create-rule-part-1--has-value-chips {
  flex-wrap: nowrap;
  align-items: flex-start;
  overflow: visible;
}
.create-rule-part-1--has-value-chips .field {
  width: 46%;
  flex: 0 0 46%;
  min-width: 0;
  align-self: flex-start;
}
.create-rule-part-1--has-value-chips .select-operator {
  width: 14%;
  flex: 0 0 14%;
  align-self: flex-start;
}

.create-value-col {
  width: 36%;
  flex: 0 0 36%;
  min-width: 0;
  margin-left: 1%;
  align-self: flex-start;
}
.create-value-col .rule-value-inline-field.mat-mdc-form-field {
  width: 100%;
  margin-left: 0;
}

.create-rule-part-2--has-value-chips {
  align-items: flex-start;
  margin-top: 10px;
}
.create-rule-part-2--has-value-chips .create-form-actions {
  align-self: center;
}

.rule-name {
  width: 100%;
  margin-right: 1%;
}

.add-or-edit-button {
  width: 100%;
  margin-left: 1%;
  margin-right: 0.5%;
}

.trapezoid-banner {
  width: 80%;
  height: 80%;
  background-color: #17a0b4;
  color: white;
  font-weight: bold;
  text-align: center;
  border: none;
  text-orientation: upright;
  writing-mode: vertical-lr;
  -webkit-clip-path: polygon(0% 0%, 100% 14%, 100% 85%, 0% 100%);
          clip-path: polygon(0% 0%, 100% 14%, 100% 85%, 0% 100%);
}

.clear-button {
  width: 11%;
  background-color: #17a2b8;
  color: white;
  letter-spacing: normal;
  width: 100%;
  margin-left: 0.5%;
}

.create-rules {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
}

.create-rule-sub-1 {
  width: 100%;
  flex: 0 0 auto;
  min-height: 27%;
  display: flex;
  flex-direction: column;
}

.create-rule-sub-2 {
  height: 100%;
  display: flex;
  width: 100%;
  flex-direction: column;
}

.create-rules-container {
  display: flex;
  overflow: auto;
  background-color: #E8FCFF;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.rule-display-header {
  display: flex;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  flex-direction: column;
}

.rule-display-header-sub-1 {
  box-sizing: border-box;
  display: flex;
  height: 100%;
  background-color: #17A2B8;
  justify-content: center;
  align-items: center;
  padding-left: 3.5%;
}

/* COMMENTED OUT: :host ::ng-deep did not reliably style CDK overlay panel (scroll fix)
:host ::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.rule-field-autocomplete-scroll-panel {
    max-height: min(50vh, 320px) !important;
    min-height: 0 !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    pointer-events: auto !important;
    touch-action: auto !important;
}

:host ::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.rule-field-autocomplete-scroll-panel.mdc-menu-surface {
    min-height: 0 !important;
    overflow-y: auto !important;
}
*/
/* ADDED: Field mat-autocomplete scroll panel (Rule Child screen only) — unique class scopes styles to this screen */
::ng-deep body .cdk-overlay-pane:has(.rule-field-autocomplete-scroll-panel) {
  z-index: 10100 !important;
}

::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.rule-field-autocomplete-scroll-panel {
  max-height: min(50vh, 320px) !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  pointer-events: auto !important;
  touch-action: auto !important;
}

::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.rule-field-autocomplete-scroll-panel.mdc-menu-surface {
  min-height: 0 !important;
  overflow-y: auto !important;
}

/* ADDED: Operator mat-select — let clicks pass through transparent backdrop while panel is open */
::ng-deep body.create-rules-operator-select-open .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  pointer-events: none !important;
}

/* ADDED: keep Operator options panel above Rule Builder dialog content */
::ng-deep .mat-mdc-select-panel.create-rules-operator-select-panel {
  z-index: 10001 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/rule-config-component/create-rules/create-rules.component.scss","webpack://./src/app/shared/styles/rule-value-chips.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,6FAAA;AAKA;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;ADFF;;ACKA,uFAAA;AACA;EACE,kBAAA;ADFF;;ACKA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,gBAjC4B;EAkC5B,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,qBAAA;EACA,oCAAA;ADFF;ACIE;EACE,UAAA;ADFJ;ACKE;EACE,mBAAA;EACA,kBAAA;ADHJ;;ACOA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;ADJF;;ACOA;EACE,eAAA;EACA,0BAAA;EACA,UAAA;ADJF;;ACOA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;ADJF;;ACOA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ADJF;;ACOA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;ADJF;ACME;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;ADJJ;ACOE;EACE,mBAAA;EACA,cAAA;ADLJ;;AApHA;EA6EI,oFAAA;AA2CJ;AAtHI;;;;EAII,iCAAA;EACA,qEAAA;AAwHR;AArHI;;EAEI,qDAAA;AAuHR;AArHQ;;EACI,wBAAA;AAwHZ;AApHI;EACI,2BAAA;EACA,4BAAA;EACA,8BAAA;AAsHR;AAnHI;EACI,uBAAA;EACA,cAAA;EACA,yBAAA;AAqHR;AAlHI;EACI,yBAAA;EACA,YAAA;AAoHR;AAjHI;EACI,WAAA;AAmHR;AA1GI;EAGI,uBAAA;EACA,gBAAA;EACA,mBAAA;AA0GR;AAvGI;EACI,mCAAA;AAyGR;AAtGI;EACI,SAAA;AAwGR;AArGI;;EAQI,oBAAA;EACA,iCAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;AAiGR;AA5FQ;EACI,mBAAA;EACA,sCAAA;AA8FZ;AA3FQ;EACI,oBAAA;EACA,iCAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;AA6FZ;AAzFI;ECiCF,WAAA;EACA,oBAAA;EACA,sBAAA;EACA,4BAAA;EACA,kDAAA;EACA,2DAAA;EAuCA,+EAAA;ADqBF;AC1DE;EACE,wBAAA;AD4DJ;ACzDE;;EAEE,2BAAA;EACA,4BAAA;EACA,uBAAA;EACA,4BAAA;EACA,8BAAA;EACA,kBAAA;AD2DJ;ACxDE;EACE,4BAAA;EACA,uBAAA;EACA,4BAAA;EACA,uBAAA;AD0DJ;ACvDE;EACE,4BAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;ADyDJ;ACtDE;;;EAGE,gCAAA;ADwDJ;ACpDE;;EAEE,oBAAA;EACA,iCAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;EACA,0BAAA;EACA,UAAA;ADsDJ;ACnDE;EAGE,gCAAA;ADmDJ;AChDE;EAEE,yBAAA;ADiDJ;;AA9IA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AAiJJ;;AA9IA;EACI,cAAA;EACA,eAAA;EACA,cAAA;AAiJJ;;AA9IA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AAiJJ;;AA9IA;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAiJJ;;AA9IA;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAiJJ;;AA9IA;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,+BAAA;EACA,eAAA;AAiJJ;;AA9IA;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,+BAAA;EACA,eAAA;AAiJJ;;AA9IA;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,sBAAA;AAiJJ;;AA9IA;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,eAAA;AAiJJ;;AA7IA;EACI,UAAA;EACA,gBAAA;AAgJJ;;AA7IA;EACI,UAAA;EACA,eAAA;EACA,gBAAA;AAgJJ;;AA7IA;EACI,UAAA;EACA,eAAA;AAgJJ;;AA7IA;EACI,iBAAA;EACA,uBAAA;EACA,iBAAA;AAgJJ;AA9II;EACI,UAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;AAgJR;AA7II;EACI,UAAA;EACA,aAAA;EACA,sBAAA;AA+IR;;AA3IA;EACI,UAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;AA8IJ;AA5II;EACI,WAAA;EACA,cAAA;AA8IR;;AA1IA;EACI,uBAAA;EACA,gBAAA;AA6IJ;AA3II;EACI,kBAAA;AA6IR;;AAzIA;EACI,WAAA;EACA,gBAAA;AA4IJ;;AAzIA;EACI,WAAA;EAKA,eAAA;EACA,kBAAA;AAwIJ;;AApIA;EACI,UAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,8DAAA;UAAA,sDAAA;AAuIJ;;AApIA;EACI,UAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AAuIJ;;AApIA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAuIJ;;AApIA;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AAuIJ;;AApIA;EACI,YAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;AAuIJ;;AApIA;EACI,aAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AAuIJ;;AApIA;EACI,aAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AAuIJ;;AApIA;EACI,sBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAuIJ;;AApIA;;;;;;;;;;;;;;CAAA;AAgBA,oHAAA;AACA;EACI,yBAAA;AAsIJ;;AAnIA;EACI,uCAAA;EACA,wBAAA;EACA,2BAAA;EACA,6BAAA;EACA,+BAAA;EACA,6BAAA;AAsIJ;;AAnIA;EACI,wBAAA;EACA,2BAAA;AAsIJ;;AAnIA,kGAAA;AACA;EAEI,+BAAA;AAqIJ;;AAlIA,yEAAA;AACA;EACI,yBAAA;AAqIJ","sourcesContent":["@import '../../shared/styles/rule-value-chips.scss';\r\n\r\n:host ::ng-deep {\r\n\r\n    .mdc-text-field--filled:not(.mdc-text-field--disabled),\r\n    .mdc-text-field--focused,\r\n    .mdc-text-field--filled,\r\n    .mat-mdc-form-field {\r\n        background-color: #fff !important;\r\n        --mdc-filled-text-field-focus-active-indicator-color: none !important;\r\n    }\r\n\r\n    .mat-mdc-form-field-type-mat-input,\r\n    .mat-mdc-form-field-type-mat-select {\r\n        --mdc-filled-text-field-focus-label-text-color: black;\r\n\r\n        .mat-mdc-form-field-subscript-wrapper {\r\n            display: none !important;\r\n        }\r\n    }\r\n\r\n    .mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-form-field-infix {\r\n        min-height: 40px !important;\r\n        padding-top: 14px !important;\r\n        padding-bottom: 6px !important;\r\n    }\r\n\r\n    .mat-mdc-raised-button.mat-basic {\r\n        background-color: white;\r\n        color: #17A2B8;\r\n        border: 1px #17A2B8 solid;\r\n    }\r\n\r\n    .mat-mdc-raised-button.mat-primary {\r\n        background-color: #17A2B8;\r\n        color: white;\r\n    }\r\n\r\n    .mat-mdc-raised-button:disabled {\r\n        color: grey;\r\n    }\r\n\r\n    // COMMENTED OUT: z-index:1 on all cdk-overlay-pane broke Operator mat-select backdrop/panel stacking inside Rule Builder MatDialog (screen freeze).\r\n    // .cdk-overlay-pane {\r\n    //     z-index: 1;\r\n    //     /* Adjust value as needed */\r\n    // }\r\n\r\n    .cardContect {\r\n        // display: flex;\r\n        // justify-content: center;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .matoutlinestyles.mat-mdc-form-field .mdc-text-field--outlined {\r\n        padding: 3px 8px 3px 8px !important;\r\n    }\r\n\r\n    .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {\r\n        top: 22px;\r\n    }\r\n\r\n    .rule-value-inline-field.mat-mdc-form-field\r\n      .mat-mdc-text-field-wrapper\r\n      .mat-mdc-form-field-flex\r\n      .mat-mdc-floating-label,\r\n    .rule-value-inline-field.mat-mdc-form-field\r\n      .mat-mdc-text-field-wrapper\r\n      .mat-mdc-form-field-flex\r\n      .mdc-floating-label {\r\n        top: -9px !important;\r\n        transform: scale(0.75) !important;\r\n        transform-origin: left top;\r\n        background: #fff;\r\n        padding: 0 4px;\r\n    }\r\n\r\n    /* Rule Name row — keep empty label centered; floated state sits on notch with gap */\r\n    .rule-name.mat-mdc-form-field {\r\n        .mdc-floating-label:not(.mdc-floating-label--float-above) {\r\n            top: 50% !important;\r\n            transform: translateY(-50%) !important;\r\n        }\r\n\r\n        .mdc-floating-label--float-above {\r\n            top: -9px !important;\r\n            transform: scale(0.75) !important;\r\n            transform-origin: left top;\r\n            background: #fff;\r\n            padding: 0 4px;\r\n        }\r\n    }\r\n\r\n    .rule-value-inline-field.mat-mdc-form-field {\r\n        @include rule-value-inline-mat-field();\r\n    }\r\n}\r\n\r\n.rule-name-cell {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 4px;\r\n    max-width: 100%;\r\n}\r\n\r\n.rule-in-expression-icon {\r\n    color: #16a34a;\r\n    font-size: 14px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.rule-value-cell {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 4px;\r\n    max-width: 100%;\r\n}\r\n\r\n.rule-value-primary {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    min-width: 0;\r\n}\r\n\r\n.rule-value-extra-badge {\r\n    flex-shrink: 0;\r\n    color: #2563eb;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n}\r\n\r\n.edit-button {\r\n    height: 100%;\r\n    width: 100%;\r\n    background-color: #F5F5F5;\r\n    border-radius: 0px 10px 0px 0px;\r\n    cursor: pointer;\r\n}\r\n\r\n.delete-button {\r\n    height: 100%;\r\n    width: 100%;\r\n    background-color: #F5F5F5;\r\n    border-radius: 0px 0px 10px 0px;\r\n    cursor: pointer;\r\n}\r\n\r\n.create-rule-part-1 {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    flex: 0 0 auto;\r\n    align-items: flex-start;\r\n    padding: 1% 2% 0.5% 2%;\r\n}\r\n\r\n.create-rule-part-2 {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    flex: 0 0 auto;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0.5% 2% 1% 2%;\r\n    margin-top: 8px;\r\n}\r\n\r\n\r\n.field {\r\n    width: 46%;\r\n    margin-right: 1%;\r\n}\r\n\r\n.select-operator {\r\n    width: 14%;\r\n    margin-left: 1%;\r\n    margin-right: 1%;\r\n}\r\n\r\n.value {\r\n    width: 36%;\r\n    margin-left: 1%;\r\n}\r\n\r\n.create-rule-part-1--has-value-chips {\r\n    flex-wrap: nowrap;\r\n    align-items: flex-start;\r\n    overflow: visible;\r\n\r\n    .field {\r\n        width: 46%;\r\n        flex: 0 0 46%;\r\n        min-width: 0;\r\n        align-self: flex-start;\r\n    }\r\n\r\n    .select-operator {\r\n        width: 14%;\r\n        flex: 0 0 14%;\r\n        align-self: flex-start;\r\n    }\r\n}\r\n\r\n.create-value-col {\r\n    width: 36%;\r\n    flex: 0 0 36%;\r\n    min-width: 0;\r\n    margin-left: 1%;\r\n    align-self: flex-start;\r\n\r\n    .rule-value-inline-field.mat-mdc-form-field {\r\n        width: 100%;\r\n        margin-left: 0;\r\n    }\r\n}\r\n\r\n.create-rule-part-2--has-value-chips {\r\n    align-items: flex-start;\r\n    margin-top: 10px;\r\n\r\n    .create-form-actions {\r\n        align-self: center;\r\n    }\r\n}\r\n\r\n.rule-name {\r\n    width: 100%;\r\n    margin-right: 1%;\r\n}\r\n\r\n.add-or-edit-button {\r\n    width: 100%;\r\n    // height: 50%;\r\n    // border-radius: 5px;\r\n    // background-color: #17A2B8;\r\n    // color: white;\r\n    margin-left: 1%;\r\n    margin-right: 0.5%;\r\n    // border: none;\r\n}\r\n\r\n.trapezoid-banner {\r\n    width: 80%;\r\n    height: 80%;\r\n    background-color: #17a0b4;\r\n    color: white;\r\n    font-weight: bold;\r\n    text-align: center;\r\n    border: none;\r\n    text-orientation: upright;\r\n    writing-mode: vertical-lr;\r\n    clip-path: polygon(0% 0%, 100% 14%, 100% 85%, 0% 100%);\r\n}\r\n\r\n.clear-button {\r\n    width: 11%;\r\n    background-color: #17a2b8;\r\n    color: white;\r\n    letter-spacing: normal;\r\n    width: 100%;\r\n    margin-left: 0.5%;\r\n}\r\n\r\n.create-rules {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n    flex-direction: column;\r\n}\r\n\r\n.create-rule-sub-1 {\r\n    width: 100%;\r\n    flex: 0 0 auto;\r\n    min-height: 27%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.create-rule-sub-2 {\r\n    height: 100%;\r\n    display: flex;\r\n    width: 100%;\r\n    flex-direction: column;\r\n}\r\n\r\n.create-rules-container {\r\n    display: flex;\r\n    overflow: auto;\r\n    background-color: #E8FCFF;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.rule-display-header {\r\n    display: flex;\r\n    width: 100%;\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n    flex-direction: column;\r\n}\r\n\r\n.rule-display-header-sub-1 {\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    height: 100%;\r\n    background-color: #17A2B8;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding-left: 3.5%;\r\n}\r\n\r\n/* COMMENTED OUT: :host ::ng-deep did not reliably style CDK overlay panel (scroll fix)\r\n:host ::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.rule-field-autocomplete-scroll-panel {\r\n    max-height: min(50vh, 320px) !important;\r\n    min-height: 0 !important;\r\n    overflow-y: auto !important;\r\n    overflow-x: hidden !important;\r\n    pointer-events: auto !important;\r\n    touch-action: auto !important;\r\n}\r\n\r\n:host ::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.rule-field-autocomplete-scroll-panel.mdc-menu-surface {\r\n    min-height: 0 !important;\r\n    overflow-y: auto !important;\r\n}\r\n*/\r\n\r\n/* ADDED: Field mat-autocomplete scroll panel (Rule Child screen only) — unique class scopes styles to this screen */\r\n::ng-deep body .cdk-overlay-pane:has(.rule-field-autocomplete-scroll-panel) {\r\n    z-index: 10100 !important;\r\n}\r\n\r\n::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.rule-field-autocomplete-scroll-panel {\r\n    max-height: min(50vh, 320px) !important;\r\n    min-height: 0 !important;\r\n    overflow-y: auto !important;\r\n    overflow-x: hidden !important;\r\n    pointer-events: auto !important;\r\n    touch-action: auto !important;\r\n}\r\n\r\n::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.rule-field-autocomplete-scroll-panel.mdc-menu-surface {\r\n    min-height: 0 !important;\r\n    overflow-y: auto !important;\r\n}\r\n\r\n/* ADDED: Operator mat-select — let clicks pass through transparent backdrop while panel is open */\r\n::ng-deep body.create-rules-operator-select-open\r\n    .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {\r\n    pointer-events: none !important;\r\n}\r\n\r\n/* ADDED: keep Operator options panel above Rule Builder dialog content */\r\n::ng-deep .mat-mdc-select-panel.create-rules-operator-select-panel {\r\n    z-index: 10001 !important;\r\n}","/* Shared chip Value field — Rule Config + Pipeline Rules (mat-form-field notched outline). */\r\n\r\n$rule-value-chips-max-height: 96px;\r\n$rule-value-field-max-height: 140px;\r\n\r\n.rule-value-inline-shell {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  box-sizing: border-box;\r\n  min-height: 20px;\r\n  height: auto;\r\n  padding: 0;\r\n  margin: 0;\r\n  background: transparent;\r\n  border: none;\r\n  border-radius: 0;\r\n}\r\n\r\n/* Inside mat-form-field — clear floated label notch; chips must not touch top border */\r\n.rule-value-inline-field .rule-value-inline-shell {\r\n  padding: 8px 0 4px;\r\n}\r\n\r\n.rule-value-inline-chips {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n  gap: 6px;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  max-height: $rule-value-chips-max-height;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #94a3b8 transparent;\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 6px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background: #94a3b8;\r\n    border-radius: 3px;\r\n  }\r\n}\r\n\r\n.rule-value-inline-input {\r\n  display: block;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  min-width: 0;\r\n  min-height: 20px;\r\n  flex: 0 0 auto;\r\n  margin: 0;\r\n  padding: 0;\r\n  border: none;\r\n  outline: none;\r\n  font-size: 12px;\r\n  line-height: 20px;\r\n  background: transparent;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.rule-value-inline-input::placeholder {\r\n  font-size: 12px;\r\n  color: rgba(0, 0, 0, 0.42);\r\n  opacity: 1;\r\n}\r\n\r\n.rule-value-tag {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  max-width: 100%;\r\n  padding: 3px 6px 3px 10px;\r\n  background: #e8f4fd;\r\n  border: 1px solid #7dd3fc;\r\n  border-radius: 16px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.rule-value-tag-text {\r\n  flex: 0 1 auto;\r\n  min-width: 0;\r\n  max-width: 200px;\r\n  font-size: 11px;\r\n  line-height: 1.35;\r\n  color: #0c4a6e;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.rule-value-tag-remove {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  width: 18px;\r\n  height: 18px;\r\n  padding: 0;\r\n  border: none;\r\n  border-radius: 50%;\r\n  background: transparent;\r\n  color: #64748b;\r\n  cursor: pointer;\r\n\r\n  mat-icon {\r\n    width: 14px;\r\n    height: 14px;\r\n    font-size: 14px;\r\n    line-height: 14px;\r\n  }\r\n\r\n  &:hover {\r\n    background: #fee2e2;\r\n    color: #dc2626;\r\n  }\r\n}\r\n\r\n@mixin rule-value-inline-mat-field() {\r\n  width: 100%;\r\n  margin: 0 !important;\r\n  align-self: flex-start;\r\n  overflow: visible !important;\r\n  --mat-form-field-container-height: auto !important;\r\n  --mdc-outlined-text-field-container-height: auto !important;\r\n\r\n  .mat-mdc-form-field-subscript-wrapper {\r\n    display: none !important;\r\n  }\r\n\r\n  .mat-mdc-text-field-wrapper,\r\n  .mdc-text-field--outlined {\r\n    min-height: 36px !important;\r\n    max-height: $rule-value-field-max-height !important;\r\n    height: auto !important;\r\n    overflow: visible !important;\r\n    background: #ffffff !important;\r\n    border-radius: 4px;\r\n  }\r\n\r\n  .mat-mdc-form-field-flex {\r\n    max-height: $rule-value-field-max-height !important;\r\n    height: auto !important;\r\n    overflow: visible !important;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .mat-mdc-form-field-infix {\r\n    max-height: calc($rule-value-field-max-height - 10px) !important;\r\n    height: auto !important;\r\n    min-height: 28px !important;\r\n    width: 100%;\r\n    overflow: visible !important;\r\n    padding-top: 4px !important;\r\n    padding-bottom: 8px !important;\r\n  }\r\n\r\n  .mdc-notched-outline__leading,\r\n  .mdc-notched-outline__notch,\r\n  .mdc-notched-outline__trailing {\r\n    border-color: #cfd8e3 !important;\r\n  }\r\n\r\n  /* floatLabel=\"always\" + chip content — keep Value label on the outline notch */\r\n  .mat-mdc-floating-label,\r\n  .mdc-floating-label {\r\n    top: -9px !important;\r\n    transform: scale(0.75) !important;\r\n    transform-origin: left top;\r\n    background: #fff;\r\n    padding: 0 4px;\r\n    color: rgba(0, 0, 0, 0.6) !important;\r\n    font-size: 12px !important;\r\n    z-index: 1;\r\n  }\r\n\r\n  &.mat-focused .mdc-notched-outline__leading,\r\n  &.mat-focused .mdc-notched-outline__notch,\r\n  &.mat-focused .mdc-notched-outline__trailing {\r\n    border-color: #0f766e !important;\r\n  }\r\n\r\n  &.mat-focused .mat-mdc-floating-label,\r\n  &.mat-focused .mdc-floating-label {\r\n    color: #0f766e !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
